import React from "react";


import SpecialCarrefour from "../../common/SpecialCarrefour";
import EmptyArticle from "../../common/EmptyArticle";

const ASpecialCarrefour = props => {
    let article = EmptyArticle();
    const { settings } = props;
    article.link = settings.link;
    article.img = settings.img;
    article.title = settings.title;
    article.embed = settings.embed;
    article.description = settings.description;

    return (
        <div className={props.classes} {...props.events} >
            <SpecialCarrefour
                article={article}
                {...props}
            />
        </div>
    );
};


export default ASpecialCarrefour;
